import { Framework } from '@/framework/instance';
import { type ContextMenuPlugin, type GetCustomContextMenuFn } from '../context-menu';
import { type TextEditPlugin } from '../text-edit';

interface IContextMenu {
    registerContextMenu: (customContextMenuFn: GetCustomContextMenuFn) => void;
    unregisterContextMenu: () => void;
}

export class TableEdit extends Framework implements IContextMenu {
    private tryGetContextMenu() {
        const contextMenu = this.framework.getInstance<ContextMenuPlugin>('ContextMenuPlugin');
        if (!contextMenu) {
            throw new Error('ContextMenuPlugin is not found');
        }
        return contextMenu;
    }

    private tryGetTextEdit() {
        const textEdit = this.framework.getInstance<TextEditPlugin>('TextEditPlugin');
        if (!textEdit) {
            throw new Error('TextEditPlugin is not found');
        }
        return textEdit;
    }

    constructor(identity: string) {
        super(identity);
        this.registerContextMenu = this.registerContextMenu.bind(this);
        this.unregisterContextMenu = this.unregisterContextMenu.bind(this);
        this.getEditingLayer = this.getEditingLayer.bind(this);
        this.enterEditing = this.enterEditing.bind(this);
        this.exitEditing = this.exitEditing.bind(this);
    }

    registerContextMenu(customContextMenuFn: GetCustomContextMenuFn) {
        this.tryGetContextMenu().registerContextMenu(customContextMenuFn);
    }

    unregisterContextMenu() {
        this.tryGetContextMenu().unregisterContextMenu();
    }

    getEditingLayer() {
        return this.tryGetTextEdit().getEditingLayer();
    }

    enterEditing(layerId: string) {
        return this.tryGetTextEdit().enterEditing(layerId);
    }

    exitEditing() {
        return this.tryGetTextEdit().exitEditing();
    }
}
